import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_COST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import CostsOverviewForm from '../../components/OperationCosts/OperatingCostsOverView/CostsOverviewForm';

export const Route = createFileRoute('/_authenticated/costs/add')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_COST, ['create'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.add',
        suffix: 'menu.costs',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  return <CostsOverviewForm selectedId={null} customerIds={null} />;
}
